var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { useUserContext } from '@web/contexts/User';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { NavigateTo } from '@web/router/NavigateTo';
import { filterUsersByOrgUnitAndRole, getUserOrgUnit } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useHasScope } from '@web/utility/hooks/useHasScope';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { CanAccess } from '@web/utility/wrapper/CanAccess';
import { ScopeUIFilterEnum, UserRoles } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export function UsersFilterSelect(_a) {
    var _b;
    var _c = _a.showAllOption, showAllOption = _c === void 0 ? true : _c, _d = _a.isVisible, isVisible = _d === void 0 ? true : _d, label = _a.label, placeholder = _a.placeholder, _e = _a.isDisplayLabel, isDisplayLabel = _e === void 0 ? true : _e, _f = _a.isOpenByDefault, isOpenByDefault = _f === void 0 ? false : _f, _g = _a.isDefaultUserSelected, isDefaultUserSelected = _g === void 0 ? true : _g, role = _a.role;
    var users = useWorkspaceCtx().users;
    var currentUser = useUserContext().currentUser;
    var filters = useFilters();
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var hasScopeUserFilter = useHasScope(ScopeUIFilterEnum.FILTER_USER);
    var defaultLabel = role === UserRoles.MANAGER ? 'filters.manager' : 'filters.user';
    var defaultPlaceholder = role === UserRoles.MANAGER ? 'filters.selectManager' : 'filters.selectUser';
    var filteredByRole = filterUsersByOrgUnitAndRole(users, filters.orgUnit, role);
    var usersOptions = __spreadArray(__spreadArray([], (showAllOption && hasScopeUserFilter
        ? [
            {
                id: null,
                name: t('filters.allEmployees'),
                isAll: true
            }
        ]
        : []), true), filteredByRole.map(function (user) { return ({
        id: user.id,
        name: user.name || user.email,
        avatar: user.avatar
    }); }), true);
    var selectedUser = usersOptions.find(function (user) { return user.id === filters.user; });
    function onChange(newOption) {
        var newFilters = {
            user: newOption.id
        };
        if (newOption.id) {
            var selectedUser_1 = users.find(function (u) { return u.id === newOption.id; });
            var userOrgUnit = getUserOrgUnit(selectedUser_1);
            if (userOrgUnit) {
                newFilters.orgUnit = userOrgUnit;
            }
        }
        navigateTo({
            pathname: location.pathname,
            newFilters: newFilters
        });
    }
    if (!selectedUser && !isOpenByDefault && isDefaultUserSelected) {
        return (_jsx(NavigateTo, { pathname: location.pathname, newFilters: { user: ((_b = usersOptions[0]) === null || _b === void 0 ? void 0 : _b.id) || null } }));
    }
    if (!hasScopeUserFilter && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) !== filters.user) {
        var currentUserOption = usersOptions.find(function (user) { return user.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id); });
        if (currentUserOption) {
            return (_jsx(NavigateTo, { pathname: location.pathname, newFilters: { user: currentUserOption.id } }));
        }
        return null;
    }
    return isVisible ? (_jsx(CanAccess, __assign({ scope: ScopeUIFilterEnum.FILTER_USER }, { children: _jsx("div", __assign({ className: "w-full sm:max-w-72" }, { children: _jsx(Select, { label: t(label || defaultLabel), isDisplayLabel: isDisplayLabel, selected: selectedUser || null, options: usersOptions, onChange: onChange, placeholder: t(placeholder || defaultPlaceholder), showAvatars: true, withSearchField: true, valueClassName: (selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.id) ? undefined : 'text-gray-500', isOpenByDefault: isOpenByDefault }) })) }))) : null;
}
